define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./customerActions", "../../utils/LookupDataSources"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, CustomerActions, LookupDataSources) {
    "use strict";
    var Customers = /** @class */ (function () {
        function Customers() {
            this.filterByServer = ko.observable("");
            this.filterByAccountManager = ko.observable();
            this.filterByProjectManager = ko.observable();
            this.filterByAgent = ko.observable();
            this.filterByAny = ko.observable("");
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Customers.Export"));
            this.userCanBulkEdit = ko.observable(UserContext.hasAccess("Admin,Customers.BulkEdit"));
            this.customerActions = new CustomerActions();
        }
        Customers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customers");
            tools.ajaxGet({
                url: "/Customers/GetCustomersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.customersLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.customersLookupLists.GridStructures.CustomersStructure);
                    self.customerActions.saveCustomerCallback = function (resultData) {
                        if (resultData) {
                            if (resultData.Id) {
                                window.location.assign("/Customers/Edit/".concat(resultData.Id));
                            }
                            else {
                                self.customersTable.refresh();
                            }
                        }
                    };
                    $(".js-new-customer").on("click", function (event) {
                        self.customerActions.editCustomer();
                        event.preventDefault();
                    });
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        Customers.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/Customers/Edit/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i></a>");
                    if (UserContext.hasAccess("Admin,Customers.Delete")) {
                        html += "&nbsp;<button class=\"btn btn-sm btn-danger btn-remove\" href=\"#\"><i class=\"fa fa-trash-o \"></i></button>";
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.customersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Customers/GetCustomers",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByServer()) {
                                    data.serverIp = self.filterByServer();
                                }
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                if (self.filterByAccountManager()) {
                                    data.accountManagerId = self.filterByAccountManager();
                                }
                                if (self.filterByProjectManager()) {
                                    data.projectManagerId = self.filterByProjectManager();
                                }
                                if (self.filterByAgent()) {
                                    data.agentId = self.filterByAgent();
                                }
                                if (self.multipleStatusSelector) {
                                    data.statuses = self.multipleStatusSelector.value().join(",");
                                }
                                if (self.multipleCustomerTypeSelector) {
                                    data.customerTypes = self.multipleCustomerTypeSelector.value().join(",");
                                }
                                if (self.multipleTagsSelector) {
                                    data.tags = self.multipleTagsSelector.value().join(",");
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customers-toolbar-template").html()),
                    columns: columns,
                    autoBind: false,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "Customer",
                    title: "Customers",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                    customDataAttributes: 'data-name="#=Name#"'
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                gridId: "tblCustomersKendo",
                showPagerOnTop: false,
                controller: self
            };
            self.customersTable.initGrid(gridOptions);
            $("#tblCustomersKendo tbody").on("click", ".btn-remove", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.customerActions.removeCustomerConfirm(dataItem.Id);
                event.preventDefault();
            });
            self.customerActions.removeCustomerCallback = function () {
                self.customersTable.getGridData().dataSource.read();
            };
            self.filterByServer.extend({ rateLimit: 200 }).subscribe(function () {
                self.customersTable.getGridData().dataSource.read();
            });
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.customersTable.getGridData().dataSource.read();
            });
            self.filterByAccountManager.extend({ rateLimit: 200 }).subscribe(function () {
                self.customersTable.getGridData().dataSource.read();
            });
            self.filterByProjectManager.extend({ rateLimit: 200 }).subscribe(function () {
                self.customersTable.getGridData().dataSource.read();
            });
            self.filterByAgent.extend({ rateLimit: 200 }).subscribe(function () {
                self.customersTable.getGridData().dataSource.read();
            });
            $("#tblCustomersKendo").on("reinit", function (event) {
                self.filterDropDownList = $("#filterByServerInput").kendoComboBox({
                    autoBind: false,
                    valuePrimitive: true,
                    filter: "contains",
                    placeholder: "Select server...",
                    dataTextField: "IpAddress",
                    dataValueField: "IpAddress",
                    dataSource: {
                        transport: {
                            read: {
                                url: "/Servers/GetServersLookup",
                                type: "POST",
                                dataType: "json"
                            }
                        },
                        schema: {
                            data: function (response) { return response.Data; },
                            total: "Total"
                        },
                        serverFiltering: true
                    },
                    change: function (e) {
                        self.filterByServer(e.sender.value());
                    },
                    dataBound: function (e) {
                        /*this.search("Gnocchi di nonna Alice");
                        this.select(this.selectedIndex);*/
                    }
                }).data("kendoComboBox");
                self.multipleStatusSelector = $("#filterByStatusInput").kendoMultiSelect({
                    autoBind: false,
                    valuePrimitive: true,
                    filter: "contains",
                    placeholder: "All Statuses",
                    dataTextField: "Text",
                    dataValueField: "Value",
                    autoClose: false,
                    tagMode: "single",
                    dataSource: {
                        data: self.customersLookupLists.Statuses
                    },
                    dataBound: function () {
                        $(window).trigger("resize");
                    },
                    change: function (e) {
                        $(window).trigger("resize");
                        self.customersTable.getGridData().dataSource.read();
                    }
                }).data("kendoMultiSelect");
                if (self.multipleStatusSelector) {
                    self.defaultStatuses();
                }
                self.multipleCustomerTypeSelector = $("#filterByCustomerTypeInput").kendoMultiSelect({
                    autoBind: false,
                    valuePrimitive: true,
                    filter: "contains",
                    placeholder: "All Customer Types",
                    dataTextField: "Text",
                    dataValueField: "Value",
                    autoClose: false,
                    tagMode: "single",
                    dataSource: {
                        data: self.customersLookupLists.CustomerTypes
                    },
                    dataBound: function () {
                        $(window).trigger("resize");
                    },
                    change: function (e) {
                        $(window).trigger("resize");
                        self.customersTable.getGridData().dataSource.read();
                    }
                }).data("kendoMultiSelect");
                if (self.multipleCustomerTypeSelector) {
                    self.defaultCustomerTypes();
                }
                var lookupDataSources = new LookupDataSources();
                var tagsDS = lookupDataSources.createLookupDataSource("Tags");
                self.multipleTagsSelector = $("#filterByTagInput").kendoMultiSelect({
                    autoBind: false,
                    valuePrimitive: true,
                    filter: "contains",
                    placeholder: "All Tags",
                    dataTextField: "Text",
                    dataValueField: "Id",
                    autoClose: false,
                    tagMode: "single",
                    dataSource: tagsDS,
                    dataBound: function () {
                        $(window).trigger("resize");
                    },
                    change: function (e) {
                        $(window).trigger("resize");
                        self.customersTable.refresh();
                    }
                }).data("kendoMultiSelect");
            });
            $("#tblCustomersKendo").trigger("reinit");
        };
        Customers.prototype.defaultStatuses = function () {
            var self = this;
            var activeStatuses = ko.utils.arrayFilter(self.customersLookupLists.Statuses, function (item) {
                return item.Text !== "Inactive";
            });
            self.multipleStatusSelector.value(activeStatuses.map(function (item) {
                return item.Value;
            }));
            self.multipleStatusSelector.trigger("change");
        };
        Customers.prototype.defaultCustomerTypes = function () {
            var self = this;
            var activeStatuses = ko.utils.arrayFilter(self.customersLookupLists.CustomerTypes, function (item) {
                return item.Text !== "Internet";
            });
            self.multipleCustomerTypeSelector.value(activeStatuses.map(function (item) {
                return item.Value;
            }));
            self.multipleCustomerTypeSelector.trigger("change");
        };
        Customers.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
            self.filterByServer("");
            self.filterByAccountManager(null);
            self.filterByProjectManager(null);
            self.filterByAgent(null);
            self.filterDropDownList.select(-1);
            self.defaultStatuses();
            self.defaultCustomerTypes();
            self.multipleTagsSelector.value([]);
            self.multipleTagsSelector.trigger("change");
        };
        Customers.prototype.bulkMembersEdit = function () {
            var self = this;
            var listOfIds = [];
            $("#tblCustomersKendo .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.customerActions.bulkEditMembers(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        Customers.prototype.bulkEdit = function () {
            var self = this;
            var listOfIds = [];
            $("#tblCustomersKendo .check-row:checked").each(function () {
                listOfIds.push($(this).data());
            });
            if (listOfIds.length > 0 && listOfIds.length <= 1000) {
                self.customerActions.bulkEditCustomers(listOfIds);
            }
            else if (listOfIds.length > 1000) {
                tools.error("You can edit only 1000 items at a time");
            }
            else {
                tools.error("Please select at least one item to edit");
            }
        };
        Customers.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.customersTable.exportTo();
            }
        };
        Customers.prototype.mapCustomers = function () {
            var self = this;
            self.customerActions.openCustomerMap();
        };
        Customers.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin,Customers.Logs")) {
                var dataLogs = new DataLogs("Customer");
                dataLogs.open("Customers logs");
                event.preventDefault();
            }
        };
        Customers.prototype.savePageSettings = function () {
        };
        return Customers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Customers/Index")) {
            log.log("Initialize Customers list");
            $(function () {
                (new Customers()).init();
            });
        }
    }, 0);
    return Customers;
});
//# sourceMappingURL=customers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customers.js
// module id = 206
// module chunks = 2